<template>
  <div>

    <div v-if="isMobile" class="d-flex align-items-center px-3 py-2 bg-light shadow-sm sticky-top">
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activeTabTitle }}</span>
    </div>

    <b-sidebar
      id="sales-drawer"
      title="Sales Menu"
      shadow
      bg-variant="light"
      text-variant="dark"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
      backdrop
      placement="left"
    >
      <hr/>
      <ul class="list-unstyled m-0">
        <li v-for="(tab, index) in filteredTabs" :key="index" class="mb-2">
          <b-button
            block
            squared
            :variant="activeTabIndex === index ? null : 'link'"
            class="text-left"
            @click="selectTab(index)"
          >
            <b-icon :icon="tab.icon" class="mr-2"></b-icon>
            {{ tab.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <div v-if="!isMobile">
      <b-tabs card lazy v-model="activeTabIndex">
        <b-tab
          v-for="(tab, index) in filteredTabs"
          :key="index"
          :title="tab.title"
        >
          <keep-alive>
            <component :is="tab.component"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>

    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component v-if="activeTabComponent" :is="activeTabComponent"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { BIconList, BIconBox, BIconFileText, BIconTruck, BIconClipboard, BIconArchive, BIconArrowReturnLeft } from 'bootstrap-vue';

import NewSale from '@/components/Sales/NewSale';
import LookupSale from '@/components/Sales/LookupSale';
import ListSales from '@/components/Sales/ListSales';
import ListLayAwaySales from '@/components/Sales/ListLayAwaySales';
import IssueRefunds from '@/components/Sales/IssueRefunds';
import ListRefunds from '@/components/Sales/ListRefunds';
import SalesPaymentMethods from '@/components/Sales/SalesPaymentMethods';
import ReturnMerchandise from '@/components/Sales/ReturnMerchandise';
import ListOtherSales from '@/components/Sales/ListOtherSales';
import ListDraftInvoices from '@/components/Sales/ListDraftInvoices';
import MerchandiseDue from '@/components/Sales/MerchandiseDue';

export default {
  name: 'SalesMain',
  components: {
    NewSale,
    LookupSale,
    ListSales,
    ListLayAwaySales,
    ListOtherSales,
    IssueRefunds,
    ListRefunds,
    SalesPaymentMethods,
    ReturnMerchandise,
    ListDraftInvoices,
    MerchandiseDue,
    BIconList,
    BIconBox,
    BIconClipboard,
    BIconTruck,
    BIconFileText,
    BIconArchive,
    BIconArrowReturnLeft
  },

  data() {
    return {
      drawerOpen: false,
      activeTabIndex: 0,
      isMobile: false,
      packet: { userDetails: {} },
      tabs: [
        {
          title: 'NEW INVOICE',
          icon: 'box',
          roles: ['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson'],
          component: 'NewSale'
        },
          {
        title: 'DRAFT INVOICES',
        icon: 'file-text',
        roles: ['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson','accountuser'],
        component: 'ListDraftInvoices' // New component
    },
        // {
        //   title: 'LOOKUP INVOICE',
        //   icon: 'file-text',
        //   roles: ['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson','accountuser'],
        //   component: 'LookupSale'
        // },
        {
          title: 'SALES',
          icon: 'file-text',
          roles: ['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson','accountuser'],
          component: 'ListSales'
        },
        {
          title: 'LAYAWAY SALES',
          icon: 'clipboard',
          roles: ['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson','accountuser'],
          component: 'ListLayAwaySales'
        },
          {
          title: 'EXCHANGE INVOICES',
          icon: 'file-text',
          roles: ['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson'],
          component: 'ListOtherSales'
        },
        // {
        //   title: 'SALES (PAYMENT METHODS)',
        //   icon: 'clipboard',
        //   roles: ['admin'],
        //   component: 'SalesPaymentMethods'
        // },
        // {
        //   title: 'RETURN MERCHANDISE',
        //   icon: 'arrow-return-left',
        //   roles: ['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson','accountuser'],
        //   component: 'ReturnMerchandise'
        // },
        {
          title: 'MERCHANDISE DUE',
          icon: 'truck',
          roles: ['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson','accountuser'],
          component: 'MerchandiseDue'
        },
        // {
        //   title: 'STORE CREDIT',
        //   icon: 'archive',
        //   roles: ['admin'],
        //   component: 'ListRefunds'
        // },
        
        // {
        //   title: 'ISSUE REFUNDS',
        //   icon: 'archive',
        //   roles: ['admin'],
        //   component: 'IssueRefunds'
        // }
      ]
    };
  },

  computed: {
    filteredTabs() {
      const role = this.packet.userDetails.userrole || '';
      return this.tabs.filter(tab => tab.roles.includes(role));
    },
    activeTabTitle() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.title : 'Menu';
    },
    activeTabComponent() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.component : null;
    }
  },

  methods: {
    selectTab(index) {
      this.activeTabIndex = index;
      this.drawerOpen = false;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    initializeUserDetails() {
      try {
        this.packet = JSON.parse(localStorage.packet || '{}');
        this.packet.userDetails = JSON.parse(localStorage.userDetails || '{}');
      } catch (e) {
        console.error('Error reading user data:', e);
      }
    }
  },

  created() {
    this.initializeUserDetails();
  },

  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Sales/SalesMain.vue